import React, { useState, useEffect } from "react";
import styled from "styled-components";
import { Link } from "react-router-dom";
import { useSelector, connect } from "react-redux";
import { useDetectClickOutside } from "react-detect-click-outside";

import { logout } from "../state/action-creator/index";
import reset from "../img/icons/clear.svg";
import search from "../img/icons/search.svg";
import { useHistory } from "react-router";
import axios from "axios";

const Container = styled.div`
  padding: 2px 5px;
  background-color: ${({ theme }) => theme.color.background};
  border-radius: ${({ show }) => (show ? "8px 8px 0 0" : "8px")};
  display: flex;
  align-items: flex-start;
  flex-direction: column;
  width: 100%;
  box-shadow: ${({ theme, show }) => (show ? theme.shadow.md : "")};
  @media (max-width: 1388px) {
    width: 100%;
  }
  @media (max-width: 500px) {
    position: ${({ show }) => (show ? "absolute" : "relative")};
    width: ${({ show }) => (show ? "100%" : "10%")};
    top:  ${({ show }) => (show ? "6px" : "9px")};
    left: 0;
    z-index: 9;
    &:before {
      content: "";
      height: 100vh;
      width: 100vw;
      top: -6px;
      left: 0px;
      z-index: 0;
      background: black;
      opacity: 0.7;
      position: absolute;
      display: ${({ show }) => (show ? "flex" : "none")};
    }
  }
`;
const Result = styled.div`
  background-color: ${({ theme }) => theme.color.background};
  position: absolute;
  top: 107%;
  left: -5px;
  width: calc(100% + 10px);
  z-index: 8;
  border-radius: 0 0 8px 8px;
  padding: 0px 0 6px 0px;
  display: flex;
  flex-direction: column;
  align-items: center;
  box-shadow: ${({ theme }) => theme.shadow.md};
  @media (max-width: 500px) {
    left: calc(-2% + 1px);
    width: calc(104% - 2px);
    display: ${({ text }) => (text ? "flex" : "none")};
    top: 41.4px;
  }
`;

const Form = styled.form`
  width: 100%;
  position: relative;
  background-color: ${({ theme }) => theme.color.secondaryBg};
  border-radius: 8px;
  z-index: 8px;
  @media (max-width: 500px) {
    /* background-color: ${({ theme, show }) =>
    show ? theme.color.secondaryBg : "transparent"}; */
    border: solid 7px ${({ theme }) => theme.color.background};
    border-radius: ${({ show }) => (show ? "8px 8px 0 0" : "8px")};
  }
`;
const Input = styled.input`
  width: calc(100% - 47px);
  background-color: ${({ theme }) => theme.color.secondaryBg};
  height: 35px;
  border-radius: 8px;
  padding: 0 0 0px 47px;
  color: ${({ theme }) => theme.color.darkerText};
  ::placeholder,
  ::-webkit-input-placeholder {
    color: ${({ theme }) => theme.color.primaryText};
    opacity: 0.3;
  }
  :-ms-input-placeholder {
    color: ${({ theme }) => theme.color.primaryText};
    opacity: 0.3;
  }
  @media (max-width: 500px) {
    background-color: ${({ theme, show }) =>
    show ? theme.color.secondaryBg : "transparent"};
    border-radius: ${({ show }) => (show ? "8px 8px 0px 0px" : "8px")};
    position: relative;
    padding: ${({ show }) => (show ? "0 0 0px 47px" : "0 0 0px 28px")};
    z-index: ${({ show }) => (show ? "0" : "9")};
    // display: ${({ show }) => (show ? "flex" : "none")};
  }
  z-index: 9; ;
`;
const Button = styled.button`
  position: absolute;
  width: 16px;
  height: 16px;
  left: ${({ search }) => (search ? "24px" : "")};
  right: ${({ search }) => (search ? "" : "12px")};
  transform: translate(-50%, -50%);
  top: 50%;
  background-color: transparent;
  background-image: url(${({ icon }) => icon});
  background-repeat: no-repeat;
  background-position: center;
  background-size: 16px 16px;
  @media (max-width: 1388px) {
    right: ${({ search }) => (search ? "" : "6px")};
  }
  @media (max-width: 500px) {
    display: ${({ show }) => (show ? "flex" : "none")};
  }
`;

const ButtonErase = styled(Button)`
  @media (max-width: 500px) {
    display: ${({ text, show }) => (text && show ? "flex" : "none")};
  }
`;

const Item = styled(Link)`
  width: 100%;
  display: flex;
  align-items: center;
  justify-content: flex-start;
  padding: 8px 12px;
  border-radius: 5px;
  width: calc(100% - 10px);
  background-color: ${({ theme, selected }) => selected && theme.color.secondaryBg};
  &:hover {
    background-color: ${({ theme }) => theme.color.secondaryBg};
  }
  &:first-child {
    margin-top: 10px;
  }
  @media (max-width: 500px) {
    width: 100%;
  }
`;

const Title = styled.p`
  color: ${({ theme }) => theme.color.darkerText};
  font-family: "Poppins Medium";
  font-size: 14px;
`;

const Cover = styled.img`
  width: 25px;
  height: 25px;
  margin-right: 15px;
  border-radius: 8px;
  @media (max-width: 500px) {
    width: 20px;
    height: 20px;
  }
`;

const ButtonStyle = styled(Button)`
  @media (max-width: 500px) {
    top: ${({ show }) => (show ? "" : "24%")};
  }
`;
const ButtonMobileStyle = styled(Button)`
  display: none;
  @media (max-width: 500px) {
    top: ${({ show }) => (show ? "" : "24%")};
    display: ${({ show }) => (show ? "none" : "block")};
    position: absolute;
    top: 34%;
    left: 30px;
  }
`;

const SearchResult = ({ setShow, res, text }) => {
  const [newResult, setNewResult] = useState(null);
  const [itemSelected, setItemSelected] = useState(-1);
  useEffect(() => {
    let results = []
    if (res.games !== undefined) {
      setNewResult([...res.games?.slice(0, 6), ...res.channels?.slice(0, 6)])
      results = [...res.games?.slice(0, 6), ...res.channels?.slice(0, 6)]
    }
    else setNewResult(null);
    const listener = (event) => {
      if (event.code === "ArrowDown") setItemSelected(s => (s < results.length - 1) ? (s + 1) : 0);
      else if (event.code === "ArrowUp") setItemSelected(s => (s > 0) ? (s - 1) : results.length - 1);
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [res]);

  const history = useHistory();
  useEffect(() => {
    const listener = (event) => {
      if (event.code === "Enter") {
        event.preventDefault();
        if (newResult && newResult[itemSelected] !== undefined) {
          setShow(false);
          let profile = newResult[itemSelected]?.username === undefined ? false : true
          history.push(profile ? ("/profile/" + newResult[itemSelected].username) : ("/game/" + newResult[itemSelected]._id))
        }
      }
    };
    document.addEventListener("keydown", listener);
    return () => {
      document.removeEventListener("keydown", listener);
    };
  }, [newResult, itemSelected, history, setShow])

  return (
    <Result text={text}>
      {newResult &&
        newResult.map((item, index) => {
          let profile = item?.username === undefined ? false : true
          return (
            <Item selected={index === itemSelected} onClick={() => setShow(false)} to={profile ? ("/profile/" + item.username) : ("/game/" + item._id)} key={index}>
              <Cover src={profile ? item.avatar : item.icon} />
              <Title>{profile ? item.username : item.name}</Title>
            </Item>
          );
        })}
    </Result>
  );
};

export const SearchBar = ({ logout, id }) => {
  const [text, setText] = useState("");
  const [Result, setResult] = useState([]);
  const [show, setShow] = useState(false);
  const loggedIn = useSelector((state) => state.user.isLoggedIn);
  const ref = useDetectClickOutside({
    onTriggered: handleClickOut,
    triggerKeys: ["Escape"],
  });
  function handleClickOut() {
    setShow(false);
  }
  useEffect(() => {
    if (text)
      axios
        .get(process.env.REACT_APP_SEARCH_ENDPOINT + text)
        .then((res) => {
          setResult(res.data);
        })
        .catch((err) => {
          if (err.response?.status === 401) logout();
        });
  }, [text, logout]);
  return (
    <Container show={show}>
      <Form ref={ref} show={show} >
        <Input
          id={id}
          show={show}
          onClick={() => setShow(true)}
          value={text}
          onChange={(event) => {
            event.preventDefault()
            setText(event.target.value);
            setResult((curr) => (text === "" ? curr : []));
          }}
          type="search"
          placeholder="Search..."
        />
        <ButtonStyle show={show} search icon={search} />
        {text ? (
          <ButtonErase show={show} text={text} onClick={() => setText("")} icon={reset} />
        ) : (
          ""
        )}
        {show ? <SearchResult setShow={handleClickOut} text={text} res={Result} /> : ""}
      </Form>
      <ButtonMobileStyle
        loggedIn={loggedIn}
        onClick={(e) => {
          e.preventDefault();
          setShow(true);
        }}
        show={show}
        icon={search}
      />
    </Container>
  );
};

connect({ logout })(SearchBar);
